import apartment_16 from './img/apartment_16.jpg'
import bird_box from './img/bird_box.jpg'
import experimental_film from './img/experimental_film.jpg'
import ghost_story from './img/ghost_story.jpg'
import harvest_home from './img/harvest_home.jpg'
import house_of_leaves from './img/house_of_leaves.jpg'
import it from './img/it.jpg'
import let_the from './img/let_the.jpg'
import lunar_park from './img/lunar_park.jpg'
import mexican from './img/mexican.jpg'
import pet_sematary from './img/pet_sematary.jpg'
import rings from './img/rings.jpg'
import tender_is_the_flesh from './img/tender_is_the_flesh.jpg'
import the_auctioneer from './img/the_auctioneer.jpg'
import the_exorcist from './img/the_exorcist.jpg'
import the_final_girl from './img/the_final_girl.jpg'
import the_hacienda from './img/the_hacienda.jpg'
import the_haunting from './img/the_haunting.jpg'
import the_hunger from './img/the_hunger.jpg'
import the_loop from './img/the_loop.jpg'
import the_other_black_girl from './img/the_other_black_girl.jpg'
import the_outsider from './img/the_outsider.jpg'
import the_shining from './img/the_shining.jpg'
import the_turn_of_the_screw from './img/the_turn_of_the_screw.jpg'

export const HBookItems = [
  {
    id:301,
    title:"Apartment 16",
    image: apartment_16,
    price:999,
    
  },
  {
    id:302,
    title:"Bird Box",
    image: bird_box,
    price:11699,
    
  },
  {
    id:303,
    title:"Experimental Film",
    image: experimental_film,
    price:3799,
    
  },
  {
    id:304,
    title:"Ghost Story",
    image: ghost_story,
    price:799,
    
  },
  {
    id:305,
    title:"Harvest Home",
    image: harvest_home,
    price:1699,
    
  },
  {
    id:306,
    title:"House of Leaves",
    image: house_of_leaves,
    price:829,
    
  },
  {
    id:307,
    title:"IT",
    image: it,
    price:589,
    
  },
  {
    id:308,
    title:"Let the Right One In",
    image: let_the,
    price:1319,
    
  },
  {
    id:309,
    title:"Lunar Park",
    image: lunar_park,
    price:449,
    
  },
  {
    id:310,
    title:"Mexican Gothic",
    image: mexican,
    price:499,
    
  },
  {
    id:311,
    title:"Pet Sematary",
    image:pet_sematary,
    price:589,
    
  },
  {
    id:312,
    title:"Rings",
    image: rings,
    price:1519,
    
  },
  {
    id:313,
    price:319,
    title: "Tender is the Flesh",
    image: tender_is_the_flesh,
    
  },
  {
    id:314,
    price:669,
    title: "The Auctioneer",
    image: the_auctioneer,
   
  },
  {id:315,
    price:359,
    title: "The Exorcist",
    image:  the_exorcist,
    
  },
  {
    id:316,
    price:599,
    title: "The Final Girl Support Group",
    image: the_final_girl,
    
  },
  {
    id:317,
    price:899,
    title: "The Hacienda",
    image: the_hacienda,
    
  },
  {
    id:318,
    price:879,
    title: "The Haunting of the Hill House",
    image: the_haunting,
    
  },
  {
    id:319,
    price:3479,
    title: "The Hunger",
    image: the_hunger,
    
  },
  {
    id:320,
    price:1469,
    title: "The Loop",
    image: the_loop,
    
  },
  {
    id:321,
    price:849,
    title: "The Other Black Girl",
    image: the_other_black_girl ,
    
  },
  {
    id:322,
    price:599,
    title: "The Outsider",
    image: the_outsider,
    
  },
  {
    id:323,
    price:2482,
    title: "The Shining",
    image: the_shining,
    
  },
  {
    id:324,
    price:399,
    title: "The Turn of the Screw",
    image: the_turn_of_the_screw,
    
  },
  
];